var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubblegum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_383",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29253",
    "data-name": "Group 29253",
    transform: "translate(286 10935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -286, -10935)",
    filter: "url(#Ellipse_383)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_383-2",
    "data-name": "Ellipse 383",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-princess-bubblegum",
    transform: "translate(-268.694 -10918.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50158",
    "data-name": "Path 50158",
    d: "M13,25v7.11H29.127V25Zm8.063,2.2a4.2,4.2,0,0,1-1.591-.271,2.97,2.97,0,0,1,3.181,0A4.2,4.2,0,0,1,21.063,27.2Z",
    transform: "translate(-1.869 -6.14)",
    fill: "#880e4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50159",
    "data-name": "Path 50159",
    d: "M13,16.672c0,4.024,2.478,8.43,5.864,9.815a5.631,5.631,0,0,0,4.4,0c3.387-1.385,5.864-5.791,5.864-9.815C29.127,11.813,13,11.813,13,16.672Zm8.063,6.6a2.743,2.743,0,0,1,1.591.462,4.8,4.8,0,0,1-3.181,0A2.743,2.743,0,0,1,21.063,23.27Z",
    transform: "translate(-1.869 -2.944)",
    fill: "#ffcdd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50160",
    "data-name": "Path 50160",
    d: "M21,30h4.4v2.932H21Z",
    transform: "translate(-4.005 -7.475)",
    fill: "#ffcdd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50161",
    "data-name": "Path 50161",
    d: "M27.728,38.4V41.33H16V38.4L19.665,34h4.4Z",
    transform: "translate(-2.67 -8.543)",
    fill: "#f06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50162",
    "data-name": "Path 50162",
    d: "M32.389,20.661V33.855h-7.33V17s0-2.2-5.864-2.2S13.33,17,13.33,17v16.86H6V20.661C6,10.6,12.6,6,19.194,6,26.525,6,32.389,10.6,32.389,20.661Z",
    transform: "translate(0 -1.068)",
    fill: "#f06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50163",
    "data-name": "Path 50163",
    d: "M26.661,41h2.932v2.2H26.661ZM12,41h2.932v2.2H12Z",
    transform: "translate(-1.602 -10.412)",
    fill: "#ffcdd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50164",
    "data-name": "Path 50164",
    d: "M26.66,39.857V38.4c1.532,0,1.466-.733,2.932-.733v1.466S29.666,39.762,26.66,39.857ZM14.932,38.4v1.459c-3.005-.1-2.932-.726-2.932-.726V37.665C13.466,37.665,13.466,38.4,14.932,38.4ZM23,34H18.6l-1.921,2.3a3.159,3.159,0,0,0,1.921.63,3.1,3.1,0,0,0,2.2-.872,3.1,3.1,0,0,0,2.2.872,3.159,3.159,0,0,0,1.921-.63Z",
    transform: "translate(-1.602 -8.543)",
    fill: "#6a1b9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28951",
    "data-name": "Group 28951",
    transform: "translate(10.398 24.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50165",
    "data-name": "Path 50165",
    d: "M29.593,37.4c-1.466,0-1.4.733-2.932.733l-3.372-4.046C23.6,33.447,24.4,33,25.927,33,29.593,33,29.593,34.466,29.593,37.4ZM18.3,34.085l-3.372,4.046c-1.466,0-1.466-.733-2.932-.733,0-2.932,0-4.4,3.665-4.4C17.19,33,18,33.447,18.3,34.085Z",
    transform: "translate(-12 -33)",
    fill: "#ec407a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50166",
    "data-name": "Path 50166",
    d: "M9.092,11.33A43.2,43.2,0,0,1,20.02,9.864,46.4,46.4,0,0,1,31.13,11.33,6.507,6.507,0,0,0,30.1,9.5c-1.185-.949-4.041-.54-5.681-1.1-2.928-1-4.4-4.4-4.4-4.4s-1.544,3.4-4.4,4.4c-1.632.572-4.493.15-5.681,1.1A5.051,5.051,0,0,0,9.092,11.33Z",
    transform: "translate(-0.825 -0.534)",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50167",
    "data-name": "Path 50167",
    d: "M23.6,2a1.1,1.1,0,1,0,1.1,1.1A1.1,1.1,0,0,0,23.6,2Z",
    transform: "translate(-4.405)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28952",
    "data-name": "Group 28952",
    transform: "translate(14.796 16.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50168",
    "data-name": "Path 50168",
    d: "M18.733,22a.733.733,0,1,0,.733.733A.733.733,0,0,0,18.733,22Zm7.33,0a.733.733,0,1,0,.733.733A.733.733,0,0,0,26.063,22Zm-.733,2.507a1.9,1.9,0,0,1-1.341,1.62,2.97,2.97,0,0,0-3.181,0,1.9,1.9,0,0,1-1.341-1.62c0-.674,1.3,0,2.932,0S25.33,23.833,25.33,24.507Z",
    transform: "translate(-18 -22)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50169",
    "data-name": "Path 50169",
    d: "M25.011,27.462a4.8,4.8,0,0,1-3.181,0,2.97,2.97,0,0,1,3.181,0Z",
    transform: "translate(-4.226 -6.674)",
    fill: "#e57373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblegum);
export default __webpack_public_path__ + "static/media/bubblegum.09cc89b79a4d95bdc801a7478ae4e693.svg";
export { ForwardRef as ReactComponent };